module.exports = __webpack_public_path__ + "media/mediaProfessionals/block-image-8-c4ea474d.png";